import React, { useState } from 'react';

const keyframes = `
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  @keyframes scaleIn {
    from { opacity: 0; transform: scale(0.95); }
    to { opacity: 1; transform: scale(1); }
  }
  @media (max-width: 900px) {
    .gallery-grid { grid-template-columns: repeat(2, 1fr) !important; padding: 0 30px !important; }
  }
  @media (max-width: 560px) {
    .gallery-grid { grid-template-columns: 1fr !important; padding: 0 20px !important; }
  }
`;

// Photos live in /public/images/gallery/, resized to 1200x1800.
// The number in each entry is the source filename (N.jpg -> photo-N.jpg).
// This array order IS the on-page order: filled left to right, then row by row
// (6, 17, 14 / 13, 12, 24 / 15, 8, 4 / 1, 10, 11 / 18, 7, 22 / 21, 3, 2 / 19, 23, 5).
const photos = [
  { id: 6, src: '/images/gallery/photo-6.jpg', label: 'Portfolio' },
  { id: 17, src: '/images/gallery/photo-17.jpg', label: 'Portfolio' },
  { id: 14, src: '/images/gallery/photo-14.jpg', label: 'Portfolio' },
  { id: 13, src: '/images/gallery/photo-13.jpg', label: 'Portfolio' },
  { id: 12, src: '/images/gallery/photo-12.jpg', label: 'Portfolio' },
  { id: 24, src: '/images/gallery/photo-24.jpg', label: 'Portfolio' },
  { id: 15, src: '/images/gallery/photo-15.jpg', label: 'Portfolio' },
  { id: 8, src: '/images/gallery/photo-8.jpg', label: 'Portfolio' },
  { id: 4, src: '/images/gallery/photo-4.jpg', label: 'Portfolio' },
  { id: 1, src: '/images/gallery/photo-1.jpg', label: 'Portfolio' },
  { id: 10, src: '/images/gallery/photo-10.jpg', label: 'Portfolio' },
  { id: 11, src: '/images/gallery/photo-11.jpg', label: 'Portfolio' },
  { id: 18, src: '/images/gallery/photo-18.jpg', label: 'Portfolio' },
  { id: 7, src: '/images/gallery/photo-7.jpg', label: 'Portfolio' },
  { id: 22, src: '/images/gallery/photo-22.jpg', label: 'Portfolio' },
  { id: 21, src: '/images/gallery/photo-21.jpg', label: 'Portfolio' },
  { id: 3, src: '/images/gallery/photo-3.jpg', label: 'Portfolio' },
  { id: 2, src: '/images/gallery/photo-2.jpg', label: 'Portfolio' },
  { id: 19, src: '/images/gallery/photo-19.jpg', label: 'Portfolio' },
  { id: 23, src: '/images/gallery/photo-23.jpg', label: 'Portfolio' },
  { id: 5, src: '/images/gallery/photo-5.jpg', label: 'Portfolio' },
];

const styles = {
  page: {
    minHeight: '100vh',
    background: '#0a0a0a',
    paddingTop: '120px',
    paddingBottom: '100px',
  },
  header: {
    padding: '0 60px 60px',
    maxWidth: '1400px',
    margin: '0 auto',
  },
  label: {
    fontFamily: "'Outfit', sans-serif",
    fontSize: '0.7rem',
    letterSpacing: '0.35em',
    textTransform: 'uppercase',
    color: '#c9a96e',
    marginBottom: '16px',
    display: 'block',
  },
  heading: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 'clamp(3rem, 6vw, 6rem)',
    fontWeight: 300,
    lineHeight: 1,
    color: '#f5f2ee',
  },
  headingItalic: {
    fontStyle: 'italic',
    color: '#c9a96e',
  },
  grid: {
    padding: '0 60px',
    maxWidth: '1400px',
    margin: '0 auto',
    display: 'grid',
    // Fills left to right, then wraps to the next row, matching the array order.
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '10px',
  },
  item: {
    position: 'relative',
    overflow: 'hidden',
    cursor: 'pointer',
  },
  img: {
    display: 'block',
    width: '100%',
    height: 'auto',
    transition: 'transform 0.4s ease',
  },
  overlay: {
    position: 'absolute',
    inset: 0,
    background: 'rgba(201,169,110,0.12)',
    transition: 'opacity 0.3s ease',
  },
  lightbox: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.95)',
    zIndex: 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    animation: 'fadeIn 0.2s ease',
  },
  lightboxInner: {
    maxWidth: '800px',
    maxHeight: '90vh',
    position: 'relative',
    animation: 'scaleIn 0.25s ease',
  },
  lightboxImg: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  closeBtn: {
    position: 'absolute',
    top: '-48px',
    right: 0,
    fontFamily: "'Outfit', sans-serif",
    fontSize: '0.7rem',
    letterSpacing: '0.25em',
    textTransform: 'uppercase',
    color: '#6b6560',
    cursor: 'pointer',
    transition: 'color 0.2s',
    background: 'none',
    border: 'none',
  },
};

export default function Gallery() {
  const [hovered, setHovered] = useState(null);
  const [lightbox, setLightbox] = useState(null);

  return (
    <>
      <style>{keyframes}</style>
      <div style={styles.page}>
        <div style={styles.header}>
          <span style={styles.label}>Visual</span>
          <h1 style={styles.heading}>
            Gallery<br />
          </h1>
        </div>

        <div className="gallery-grid" style={styles.grid}>
          {photos.map((photo) => (
            <div
              key={photo.id}
              style={styles.item}
              onMouseEnter={() => setHovered(photo.id)}
              onMouseLeave={() => setHovered(null)}
              onClick={() => setLightbox(photo)}
            >
              <img
                src={photo.src}
                alt={`Noah Sato — ${photo.label}`}
                style={{ ...styles.img, transform: hovered === photo.id ? 'scale(1.04)' : 'scale(1)' }}
                loading="lazy"
              />
              <div style={{ ...styles.overlay, opacity: hovered === photo.id ? 1 : 0 }} />
            </div>
          ))}
        </div>

        {/* Lightbox */}
        {lightbox && (
          <div style={styles.lightbox} onClick={() => setLightbox(null)}>
            <div style={styles.lightboxInner} onClick={(e) => e.stopPropagation()}>
              <button
                style={styles.closeBtn}
                onClick={() => setLightbox(null)}
                onMouseEnter={e => e.target.style.color = '#c9a96e'}
                onMouseLeave={e => e.target.style.color = '#6b6560'}
              >
                Close ✕
              </button>
              <img
                src={lightbox.src}
                alt={`Noah Sato — ${lightbox.label}`}
                style={styles.lightboxImg}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
}
